import React, { useCallback } from 'react';
import { MainLayout, Triptych } from '@app/components';
import { ServiceCard, ServiceList, ServiceOrders } from '@app/features/Service';
import { useResourceScreenHelpers } from '@app/hooks';
import { serviceApi } from '@app/store';
import { IService } from '@app/common';
import { FinanceHeader } from '@app/features/FinanceHeader';
import { RouteProp, useFocusEffect, useRoute } from '@react-navigation/native';
import { RootStackParamList } from '@app/types';

export const ServiceScreen = () => {
  const route = useRoute<RouteProp<RootStackParamList, 'ServiceScreen'>>();

  const [readOne, { isFetching }] = serviceApi.useLazyReadOneServicesQuery();

  const { triptych, modal, onUpdate, selectedItem, item: service } = useResourceScreenHelpers<IService>();

  const openCard = (item: Partial<IService>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item._id } },
    }), item)
  }

  useFocusEffect(
    useCallback(() => {
      if (Boolean(route.params?._id)) {
        openCard({ _id: route.params._id });
      }
    }, [route])
  );

  return (
    <MainLayout
      header={<FinanceHeader />}>

      <Triptych
        list={(
          <ServiceList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onShow={openCard}
            onDelete={modal.open} />
        )}
        card={(
          <ServiceCard
            service={service ?? selectedItem}
            toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()} />
        )}

        form={<ServiceOrders orders={service?.orders ?? []} isFetching={isFetching} />} />
    </MainLayout>
  );
};

